import { cn } from '@/lib/utils'
import type { CourseWithoutBlocks } from '@/types/course'
import { useAppDispatch } from '@/store/hooks'
import { LanguageFlag } from '@/components/layout/sidebar/LanguageFlag'
import { setContentLang } from '../../editorSlice'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { useAvailableContentLangs } from './useAvailableContentLangs'

/** Быстрое переключение языка правки кружками-флагами в углу холста. У курса с одним
 *  языком переключать нечего — ничего не рисуем. */
export const QuickLangSwitch = ({ course }: { course: CourseWithoutBlocks }) => {
  const dispatch = useAppDispatch()
  const m = useMessages(messages)
  const { current, available } = useAvailableContentLangs(course)
  if (available.length < 2) return null
  return (
    <div className="flex items-center gap-1.5">
      {available.map((lang) => (
        <button
          key={lang}
          type="button"
          aria-label={m.editLang(lang)}
          aria-pressed={current === lang}
          onClick={() => dispatch(setContentLang(lang))}
          className={cn(
            'flex size-8 shrink-0 items-center justify-center rounded-full transition',
            current === lang ? 'ring-2 ring-brand' : 'opacity-50 hover:opacity-100',
          )}
        >
          <LanguageFlag lang={lang} className="size-6" />
        </button>
      ))}
    </div>
  )
}
